import React from "react";
import { Section, Field, TextIn, Choice } from "./obUi";

const PHONE_SHOW = [
  ["both", "Landing pages and thank-you page"],
  ["thank_you", "Thank-you page only"],
  ["landers", "Landing pages only"],
  ["none", "Don't show a phone number"],
];

const LogoField = ({ logo, ro }) => (
  <Field label="Logo" wide hint="PNG, JPG or WEBP, up to 2 MB. Optional — we show your firm name if there's no logo.">
    <div className="flex items-center gap-4 flex-wrap">
      <div className="h-16 w-44 border-2 border-dashed border-zinc-400 flex items-center justify-center bg-zinc-50">
        {logo.src
          ? <img src={logo.src} alt="Your logo" className="max-h-14 max-w-[10rem] object-contain" data-testid="ob-logo-preview" />
          : <span className="text-[10px] uppercase tracking-widest text-zinc-500" data-testid="ob-logo-empty">No logo yet</span>}
      </div>
      {!ro && (
        <label className="border-2 border-black px-3 py-2 text-[11px] uppercase tracking-widest cursor-pointer hover:bg-zinc-100 transition-colors duration-100">
          {logo.busy ? "Uploading…" : logo.src ? "Change logo" : "Upload logo"}
          <input type="file" accept="image/png,image/jpeg,image/webp" className="hidden" disabled={logo.busy}
                 onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) logo.onFile(f); }}
                 data-testid="ob-logo-input" />
        </label>
      )}
    </div>
  </Field>
);

export const PagesSection = ({ a, set, ro, logo }) => {
  const p = { a, set, ro };
  return (
    <Section n={2} title="Your pages" testId="ob-section-pages"
             hint="We build your own landing pages and thank-you page with these details. No design work needed.">
      <LogoField logo={logo} ro={ro} />
      <Field label="Phone on landing pages">
        <TextIn {...p} k="lander_phone" type="tel" testId="ob-lander-phone" placeholder="(555) 123-4567" />
      </Field>
      <Field label="Phone on thank-you page" hint="Leave empty to use the landing-page number">
        <TextIn {...p} k="thankyou_phone" type="tel" testId="ob-thankyou-phone" placeholder="e.g. your intake line" />
      </Field>
      <Field label="Where should your phone number show?" wide>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {PHONE_SHOW.map(([k, label]) => (
            <Choice key={k} ro={ro} on={a.phone_display === k} onClick={() => set("phone_display", k)} testId={`ob-phone-show-${k}`}>{label}</Choice>
          ))}
        </div>
      </Field>
      <Field label="Office address">
        <TextIn {...p} k="office_address" testId="ob-office-address" placeholder="Street, city, state, ZIP" />
      </Field>
      <Field label="Office hours">
        <TextIn {...p} k="office_hours" testId="ob-office-hours" placeholder="e.g. Mon–Fri 9am–6pm" />
      </Field>
    </Section>
  );
};
